export const enum OnboardingFinalizedState {
  Completed = 'completed',
  Skipped = 'skipped',
}
